import React from "react";
import Hero from "./Hero";
import Team from "./Team";
import TeamMember from "./TeamMember";

function AboutPage() {
  return (
    <>
      <Hero />
      <Team />
      <TeamMember />
    </>
  );
}

export default AboutPage;
